import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { getLocalProductLevel, getUserData, setLocalProductLevel } from "../utils/localStorage";
import { getProductLevel } from "../services/userMasterUser";
import { getUserLead } from "../services/leads";
import { errorMessage } from "../utils/alertMessage";
import { Link } from "react-router-dom";

const DashboardOperation = () => {
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { userProfileData } = getUserData();

  const [leadData, setLeadData] = useState([])

  const toggleFilter = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const [productsLevelList, setProductsLevelList] = useState()

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 100000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    sourceIn: [],
    userIdIn: [userProfileData.id],

    recordType: "CreatedOn",
    startDate: "",
    endDate: "",
    leadTypeIn: [],
    userLeadStatusIn: ["ASSIGN", "WORKING", "ASSIGN_TO_OTHER"]
  };
  const fetchData = (data) => {

    getUserLead(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;

          // 🔥 Extract only the lead object
          // const newData = rawData.map(item => item.lead);


          setLeadData(rawData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
      });
  };

  useEffect(() => {
    fetchProductLevel()
    fetchLocalProductLevel()

    fetchData(typeData)
  }, [])

  const productLevelDataApi = {
    searchBy: "",
    searchText: "",
    limit: 100000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    productIdIn: [],
    productLevelIn: userProfileData?.userTypeInfo?.split(",").map(item => item.trim())

  };


  const fetchProductLevel = async () => {
    try {
      const response = await getProductLevel(productLevelDataApi);
      if (!response.data.error) {
        const newData = response.data.data || response.data; // adjust if API structure differs
        setLocalProductLevel(newData);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalProductLevel = async () => {
    const { productLevel } = getLocalProductLevel();
    if (productLevel && Object.keys(productLevel).length > 0) {
      setProductsLevelList(productLevel);
    } else {
      await fetchProductLevel();
    }
  };


  const statuses = ["ASSIGN", "WORKING", "ASSIGN_TO_OTHER", "DONE"];

  const leadStatusMap2 = Object.groupBy(leadData, item => item.status);

  const result = statuses.map(status => {
    const items = leadStatusMap2[status] || [];

    return {
      status,
      count: items.length,
      amount: items.reduce((sum, item) => sum + (item.lead?.amount || 0), 0)
    };
  });


  const OrderStatusColors = [
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#000",
  ];

  function formatIndianShort(value) {
    if (value == null || isNaN(value)) return "";

    const num = Number(value);

    if (num >= 10000000) {
      return (num / 10000000).toFixed(num % 10000000 === 0 ? 0 : 1) + "Cr";
    }

    if (num >= 100000) {
      return (num / 100000).toFixed(num % 100000 === 0 ? 0 : 1) + "L";
    }

    return num.toLocaleString("en-IN");
  }

  return (
    <main id="main" className="main">
      <section className="section dashboard">
        <div className="row">
          {/* Left side columns */}
          <div className="col-lg-12">
            <div className="row">
              {/* Sales Card */}
              <div className=" col-md-12">
                <div className="card info-card sales-card">
                  <div className="card-body">
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h5 className="card-title">
                        Operation Team Dashboard <span>| Financeseva</span>
                      </h5>
                      <i
                        className="pi pi-filter-fill"
                        onClick={toggleFilter}
                        style={{ color: "#1e439b" }}
                      ></i>
                      </div>

                    <div class="sec-hdr">
                      <div class="sec-ico">
                        📥
                      </div>
                      <div>
                        <div class="sec-title">Lead Box</div>
                      </div>
                    </div>

                    <div class="kpi-grid" id="kpi-grid">
                      <div class="kpi-card">
                        <div class="kpi-accent" style={{ background: "#1a6b32" }}></div>
                        <div class="kpi-icon-wrap" style={{ background: "#e8f5ed" }}><i class="pi pi-users" style={{ color: "#1a6b32", fontSize: '20px' }}></i></div>
                        <div class="kpi-label">Total Leads</div>
                        <div class="kpi-val" id="kpi-total">{leadData?.length}</div>
                        <div class="kpi-sub">All time</div>
                      </div>
                    </div>

                    <div class="sec-hdr">
                      <div class="sec-ico">
                        📥
                      </div>
                      <div>
                        <div class="sec-title">Lead Status — Lead Box</div>
                        <div class="sec-sub">No. of leads · Total loan amounts</div>
                      </div>
                    </div>

                    <div className="kpi-row-second">
                      {result.map((resultItem, index) => (
                        <div className="kpi-card"  >
                          <div className="kpi-accent" style={{ background: OrderStatusColors[index] }}></div>
                          <div className="kpi-label">{resultItem.status} - {resultItem.count}</div>
                          <div className="kpi-val">
                            ₹{formatIndianShort(resultItem.amount)}
                          </div>
                        </div>
                      ))}

                    </div>
                    {/*</div>
                    <div className="row">
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Lead Box
                              </span>
                              <span style={{ color: "#ff5501", marginLeft: 10 }}>
                                | {leadData.length} Leads
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      {result.map((resultItem) => (
                        <div className=" col-md-6">
                          <div className="card">
                            <Card title="" style={{ color: "#ff5501" }}>
                              <Link

                                to="/operation-lead/list"
                                state={{
                                  userLeadStatusIn: [resultItem.status] // ✅ send clicked status
                                }}
                              >
                                <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between" }}>
                                  <h3 className="m-0">
                                    <i className={"bi bi-box"} />
                                    <span style={{ color: "#1e439b", marginLeft: 10, textTransform: "capitalize" }}>
                                      {resultItem.status} - {resultItem.count}
                                    </span>
                                    <span style={{ color: "#ff5501", marginLeft: 10 }}>
                                      | Amount - {Math.round(resultItem.amount)?.toLocaleString("en-IN")}
                                    </span>
                                  </h3>
                                  <i
                                    className="pi pi-angle-double-right"
                                    onClick={toggleFilter}
                                    style={{ color: "#1e439b" }}
                                  ></i>
                                </div>
                              </Link>
                            </Card>
                          </div>

                        </div>
                      ))}
                    </div>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default DashboardOperation;
